import React, { useEffect, useState } from "react";
import "../NewPage/CreateForm.css";
import Popup from "reactjs-popup";
import Dialog from "@mui/material/Dialog";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form, Formio } from "@formio/react";
import "reactjs-popup/dist/index.css";

const Claim = () => {
  //  ============== all claim big sderach function
  const [comundaMainList, setcomundaMainList] = useState([]);
  const [supermainid, setsupermainid] = useState(undefined);
  const [formrendering, setformrendering] = useState({});
  const [Gotformdata, setGotformdata] = useState(undefined);

  const Navigate = useNavigate();

  useEffect(() => {
    Getwholetasklist();

    localStorage.setItem("formioToken", process.env.REACT_APP_X_JWT_TOKEN);
    localStorage.setItem("formUrl", `http://localhost:3001/form/${_first}`);
    // formrender(_first);
    // const halfsubmissionapi=`form/${_first}/submission/${_second}`;
    // GetSubmissionData(halfsubmissionapi)
  }, []);

  const Getwholetasklist = async () => {
    const response = await fetch(
      `http://localhost:8000/camunda/engine-rest-ext/v1/filter?resourceType=Task&itemCount=true`,
      {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          //   'Content-Type': 'application/json',
          Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
      }
    );
    const data = await response.json();

    await Alltasklists(data[0].id);
  };

  const Alltasklists = async (id) => {
    const response = await fetch(
      `http://localhost:8000/camunda/engine-rest-ext/v1/filter/${id}/list?firstResult=0&maxResults=1000`,
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",

          Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body:JSON.stringify(submission) // body data type must match "Content-Type" header
      }
    ).then((data) => {
      data.json().then((data) => {
        setcomundaMainList(data);
        // ====searching and asuring

        compareandset(data);
      });
    });
  };

  const compareandset = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (
        localStorage.getItem("processInstanceId") == data[i].processInstanceId
      ) {
        setsupermainid(data[i].id);
        comparendfetch(data[i].id);
      }
    }
  };

  // =========  comparing process instance id with big list and fetching form details

  const comparendfetch = async (id) => {
    const response = await fetch(
      `http://localhost:8000/camunda/engine-rest-ext/v1/task/${id}/variables`,
      {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          //   'Content-Type': 'application/json',
          Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
      }
    );
    const data = await response.json();

    const array = await data.formUrl.value.split("/");

    const webformurlcut = await data.webFormUrl.value.split("/");

    for (let i = 0; i < webformurlcut.length; i++) {
      if (webformurlcut[i] === "submission") {
        // formrender(array[i-1]);
        const halfsubmissionapi = await webformurlcut.slice(i - 2).join("/");

        GetSubmissionData(halfsubmissionapi);
      }
    }

    for (let i = 0; i < array.length; i++) {
      if (array[i] === "submission") {
        localStorage.setItem(
          "formUrl",
          `http://localhost:3001/form/${array[i - 1]}`
        );
        formrender(array[i - 1]);
      }
    }

    // showform(formid);
  };

  const formrender = async (formid) => {
    const response = await fetch(`http://localhost:3001/form/${formid}`, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        //   'Content-Type': 'application/json',

        "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then((data) => {
        data.json().then((data) => {
          setformrendering(data);
        });
      })
      .catch((err) => {});
  };

  const GetSubmissionData = async (halfsubmissionapi) => {
    const response = await fetch(`http://localhost:3001/${halfsubmissionapi}`, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        //   'Content-Type': 'application/json',

        "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then((data) => {
        data.json().then((data) => {
          setGotformdata(data);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //============
  const _first = localStorage.getItem("formid");
  const _second = localStorage.getItem("submissionid");

  const submitformapi = async (id, submitapipayload) => {
    const response = await fetch(
      `http://localhost:8000/camunda/engine-rest-ext/v1/task/${id}/submit-form`,
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(submitapipayload), // body data type must match "Content-Type" header
      }
    );
  };

  const onSubmitHandler = async (submission) => {
    // setResult(submission);
    // setSubmitted(true);

    const formio = new Formio(
      `http://localhost:3001/form/${submission.form}/submission/${submission._id}`
    );

    await formio
      .saveSubmission({ _id: submission._id, data: submission.data })
      .then((result) => {});

    const appidinnum = Number(submission.data.applicationId);

    const submitapipayload = {
      variables: {
        formUrl: {
          value: `http://${process.env.REACT_APP_MY_CURRENT_IP}:3001/form/${submission.form}/submission/${submission._id}`,
        },
        applicationId: { value: appidinnum },
        webFormUrl: {
          value: `http://${process.env.REACT_APP_MY_CURRENT_IP}:3000/form/${submission.form}/submission/${submission._id}`,
        },
        action: {
          value: !!JSON.parse(localStorage.getItem("UserDetails")).groups.find(
            (val) => val === "/formsflow/formsflow-reviewer/approver"
          )
            ? submission.data.managerActionType
            : submission.data.clerkActionType,
        },
      },
    };

    submitformapi(supermainid, submitapipayload);

    window.location.reload();

    // Navigate(`/Forms/${props.bigArray._id}`)
  };

  return (
    <div className="PopupModel">
      <div className="well mx-5">
        {formrendering && Gotformdata && (
          <Form
            form={formrendering}
            onSubmit={onSubmitHandler}
            submission={Gotformdata}
          ></Form>
        )}
      </div>
    </div>
  );
};

export default Claim;
